/*
 * Copyright 2026 Sony Corporation
 */

export interface Disposable {
  dispose: () => void;
}

/**
 * The ownership record a scene disposes through.
 *
 * Everything a scene creates is registered here, and disposal walks only this
 * list. Sweeping `scene.meshes` instead would take the editor's camera rigs and
 * gizmo with it, and forgetting an entry is a leak the §11 test catches.
 */
export class Disposables implements Disposable {
  private items: Disposable[] = [];

  add(...items: Disposable[]): void {
    this.items.push(...items);
  }

  get size(): number {
    return this.items.length;
  }

  /** Reverse order, so a material is released before the textures it references. */
  dispose(): void {
    for (let index = this.items.length - 1; index >= 0; index -= 1) {
      this.items[index].dispose();
    }
    this.items = [];
  }
}
